if (!customElements.get('final-sale-agreement')) {
  const FinalSaleAgreement = class extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.productForm = this.closest('product-form');
      if (!this.checkbox || !this.productForm) return;

      this.atcButton = this.productForm.querySelector('[name="add"]');
      this.dynamicPayment = this.productForm.querySelector('.product-dynamic-payment-button');

      this.checkbox.addEventListener('change', this.handleChange.bind(this));

      this.form = this.productForm.querySelector('.js-product-form');
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      // Re-apply disabled state after variant picker overrides it on variant change
      this.productForm.addEventListener('on:variant:change', () => this.handleChange());

      // Enforce initial state immediately (covers Quickview where variant picker already ran)
      this.handleChange();

      // Re-enforce after deferred scripts run (variant-picker.js removes disabled on init)
      requestAnimationFrame(() => this.handleChange());
    }

    handleChange() {
      if (this.checkbox.checked) {
        if (this.atcButton) this.atcButton.removeAttribute('disabled');
        if (this.dynamicPayment) this.dynamicPayment.removeAttribute('hidden');
      } else {
        if (this.atcButton) this.atcButton.setAttribute('disabled', '');
        if (this.dynamicPayment) this.dynamicPayment.setAttribute('hidden', '');
      }
    }

    handleSubmit(evt) {
      if (!this.checkbox.checked) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this.checkbox.focus();
      }
    }
  };
  customElements.define('final-sale-agreement', FinalSaleAgreement);
}
